import { useToast } from '@core/toast'
import { localizedStrings } from '@core/strings'

export const useClipboard = () => {
  const toast = useToast()

  const copyToClipboard = async (
    text: string,
    options?: { showToast?: boolean },
  ) => {
    if ('clipboard' in navigator) {
      await navigator.clipboard.writeText(text)
    } else {
      document.execCommand('copy', true, text)
    }
    if (options?.showToast ?? true) {
      toast.success(localizedStrings.copiedToClipBoard)
    }
  }

  return { copyToClipboard }
}
